<template>
    <li v-if="showMenuItem(item)" class="nav-item" :class="expandMenu ? 'dropdown show' : 'dropright'">
        <div :class="$screen.width <= 576 ? 'd-flex justify-content-between align items' : ''">
            <router-link
                class="nav-link pointer"
                :class="{'dropdown-toggle':hasChildren}"
                :exact-active-class="'active'"
                :active-class="'active'"
                :data-toggle="dataToggle"
                :aria-expanded="expandMenu"
                :aria-controls="'sidebar'"
                :to="{name:item.route ? item.route : '', params:item.params}"
                @click.native="closeMobileMenuModal"
            >
                <span
                    v-if="item.count"
                    class="badge badge-pill badge-soft-primary desk32-navigation-badge"
                    style="font-size: 10px; position: absolute; right:25px; top:0;"
                >{{ item.count }}</span>
                <i class="fe" v-if="item.icon && !hasChildren" :title="$t(item.label)" :class="item.icon"></i>
                <i class="fe" v-if="hasChildren" :class="item.icon"></i>
                <span :class="{'':level ==0}">{{ $t(item.label) }}</span>
            </router-link>

            <span
                v-if="hasChildren && $screen.width <= 576"
                class="mr-3"
                variant="white"
                @click="expandMenu = !expandMenu"
            >
                <i class="fe fe-chevron-up" v-if="expandMenu"></i>
                <i class="fe fe-chevron-down" v-else></i>
            </span>
        </div>

        <ul class="dropdown-menu" v-if="hasChildren" :class="{'show ml-4' :expandMenu}">
            <li class="dropdown-header d-none d-md-block">
                <h6 class="text-uppercase mb-0">{{ $t(item.label) }}</h6>
            </li>
            <navbar-item v-for="(child, index) in item.children" :level="level+1" :item="child" :key="index"></navbar-item>
        </ul>
    </li>
</template>

<script>
export default {
    name: 'navbar-item',
    props: { item: Object, level: Number },
    data() {
        return {
            expandMenu: false,
        }
    },
    computed: {
        hasChildren() {
            return this.item.children ? true : false;
        },
        dataToggle() {
            return this.hasChildren ? `collapse` : ``;
        }
    },
    methods: {
        showMenuItem(item) {
            if (item.skipChecks)
                return true;
            if (item.module)
                return this.$loadModule(item.module);
            return this.$hasPermission(item.resource, item.actions || ['view']);
        },
        closeMobileMenuModal() {
            this.$root.$emit('bv::hide::modal', 'mobileMenuModal')
        }
    }
}
</script>

<style scoped lang="scss">
.nav-link[data-toggle="collapse"]:after {
    display: none !important;
}
.nav-item {
    margin: 0;
    padding: 5px 0;
}
.nav-link {
    i {
        padding-top: .4rem;
    }
    & span, & i {
        transition: .15s ease-in-out;
    }
}
.active, .nav-link:hover {
    i, span {
        color: #12263F;
    }
}
.active {
    transition: .15s ease-in-out;
    background: #EDF2F9;
    &:before {
        border: 0 !important;
    }
}
.dropdown-menu {
    z-index: 25000 !important;
}
</style>
